__turbopack_context__.v({
  "confirmation": "c2FILa_confirmation",
  "confirmation__change": "c2FILa_confirmation__change",
  "confirmation__help": "c2FILa_confirmation__help",
  "confirmation__resend": "c2FILa_confirmation__resend",
  "confirmation__text": "c2FILa_confirmation__text",
  "confirmation__title": "c2FILa_confirmation__title",
  "consent": "c2FILa_consent",
});
